/**
 * 页面样式定义
 * 定义特定页面的样式
 */

import { SxProps, Theme } from "@mui/material/styles";

// 仪表板页面样式
export const dashboardStyles: Record<string, SxProps<Theme>> = {
  // Dashboard.tsx 中的样式
  root: {
    p: 3,
  },

  // 网格布局
  grid: {
    display: "grid",
    gap: 3,
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  },

  // 卡片样式
  card: {
    borderRadius: "0px",
  },

  // 卡片内容样式
  cardContent: {
    borderRadius: "0px",
  },

  // 统计卡片样式
  statCard: {
    borderRadius: "0px",
    "&:hover": {
      boxShadow: 3,
    },
  },

  // 图表容器样式
  chartContainer: {
    height: 300,
    borderRadius: "0px",
  },
};

// 注册页面样式
export const registerStyles: Record<string, SxProps<Theme>> = {
  // Register.tsx 中的样式
  root: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #1a2980 0%, #26d0ce 100%)",
  },

  // 表单容器样式
  formContainer: {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    borderRadius: "16px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    p: 4,
    maxWidth: 400,
    width: "100%",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
  },

  // 标题样式
  title: {
    textAlign: "center",
    mb: 3,
    color: "text.primary",
  },

  // 表单样式
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },

  // 输入框样式
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      "& fieldset": {
        borderColor: "rgba(26, 41, 128, 0.2)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(26, 41, 128, 0.4)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "primary.main",
      },
    },
    "& .MuiInputLabel-root": {
      color: "rgba(26, 41, 128, 0.8)",
    },
  },

  // 按钮样式
  button: {
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "bold",
    background: "linear-gradient(135deg, #1a2980 0%, #26d0ce 100%)",
    "&:hover": {
      background: "linear-gradient(135deg, #15226d 0%, #20b8b6 100%)",
      boxShadow: "0 4px 16px rgba(26, 41, 128, 0.3)",
    },
  },

  // 链接样式
  link: {
    textAlign: "center",
    mt: 2,
    color: "rgba(26, 41, 128, 0.8)",
    "&:hover": {
      color: "#1a2980",
      textDecoration: "underline",
    },
  },
};

// 介绍页面样式
export const introStyles: Record<string, SxProps<Theme>> = {
  // Intro.tsx 中的样式
  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    color: "white",
  },

  // 内容容器样式
  content: {
    textAlign: "center",
    maxWidth: 600,
    p: 3,
  },

  // 标题样式
  title: {
    fontSize: "3rem",
    fontWeight: "bold",
    mb: 2,
    textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
  },

  // 副标题样式
  subtitle: {
    fontSize: "1.5rem",
    mb: 4,
    opacity: 0.9,
  },

  // 按钮容器样式
  buttonContainer: {
    display: "flex",
    gap: 2,
    justifyContent: "center",
    flexWrap: "wrap",
  },

  // 主按钮样式
  primaryButton: {
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "1.1rem",
    px: 4,
    py: 1.5,
    "&:hover": {
      backgroundColor: "primary.dark",
    },
  },

  // 次按钮样式
  secondaryButton: {
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "1.1rem",
    px: 4,
    py: 1.5,
    borderColor: "white",
    color: "white",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.1)",
    },
  },

  // 输入框样式
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px",
      backgroundColor: "rgba(255,255,255,0.1)",
      "& fieldset": {
        borderColor: "rgba(255,255,255,0.3)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(255,255,255,0.5)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "white",
      },
    },
    "& .MuiInputLabel-root": {
      color: "rgba(255,255,255,0.7)",
    },
    "& .MuiInputBase-input": {
      color: "white",
    },
  },
};

// 用户安全页面样式
export const uSecurityStyles: Record<string, SxProps<Theme>> = {
  // USecurity.tsx 中的样式
  root: {
    p: 3,
  },

  // 纸张样式
  paper: {
    borderRadius: "0px",
    p: 3,
  },

  // 标题样式
  title: {
    mb: 3,
    color: "text.primary",
  },

  // 表单样式
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },

  // 输入框样式
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px",
    },
  },

  // 按钮样式
  button: {
    borderRadius: "0px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "primary.dark",
    },
  },
};

// 错误消息页面样式
export const errorMessageStyles: Record<string, SxProps<Theme>> = {
  // ErrorMessageArea.tsx 中的样式
  root: {
    backgroundColor: "error.light",
    color: "error.contrastText",
    padding: 2,
    borderRadius: "0px",
    marginBottom: 2,
  },

  // 错误消息文本样式
  text: {
    color: "error.contrastText",
  },

  // 关闭按钮样式
  closeButton: {
    color: "error.contrastText",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.1)",
    },
  },
};
